import axios from "axios";

export const urlApiBase = "https://apiempleadordev.coosalud.com";

const apiClient = axios.create({
    baseURL: urlApiBase,
    timeout: 1000,
    headers: {'X-Custom-Header': 'prueba'}
});

// usuarios globales
const user = "manage_portal_empleador@coosalud.com";
const pass = "wdCx6@UZdwX4ye2$BsXuc*";

// Credenciales para Auth Basic
const Username = "Coosalud";
const Password = "secret";

export const isEmail = (e:string) => {
    const patt = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return patt.test(e);
  }

export default apiClient;

